export default __webpack_public_path__ + "static/media/iit.9639e990.jpg";